export default (function () {
  var productLinks = document.querySelectorAll('.rdpProductLink');
  productLinks.forEach(function (link) {
    return link.addEventListener('click', function (event) {
      var title = event.target.text;

      if (title && GeneralMills.Analytics) {
        GeneralMills.Analytics.raiseEvent({
          EventType: 'IngredientLinkToPDP',
          LinkTitle: title.trim()
        });
      }
    });
  });
});